// plugin 组件
import WConfirmSheet from './package/confirmSheet'
import WConfirmSheetMini from './package/confirmSheetMini'
import WToast from './package/toast'
import WSearch from './package/search'
import WIcon from './package/icon'
import WImg from './package/img'

export default {
	install: function (Vue) {
		Vue.use(WConfirmSheet)
		Vue.use(WConfirmSheetMini)
		Vue.use(WToast)
		Vue.component('w-search', WSearch)
		Vue.component('w-icon', WIcon)
		Vue.component('w-img', WImg)
	}
}



// WEBPACK FOOTER //
// ./src/lib/wind-ui/index.js